module.exports = __webpack_public_path__ + "img/skiing.686f438d.jpg";